var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.92593V20H0V5.92593H4.5ZM0 1.82963C0 0.792593 0.9 0 2.25 0C3.6 0 4.4475 0.792593 4.5 1.82963C4.5 2.86667 3.66 3.7037 2.25 3.7037C0.9 3.7037 0 2.86667 0 1.82963ZM21 20H16.5C16.5 20 16.5 13.1407 16.5 12.5926C16.5 11.1111 15.75 9.62963 13.875 9.6H13.815C12 9.6 11.25 11.1259 11.25 12.5926C11.25 13.2667 11.25 20 11.25 20H6.75V5.92593H11.25V7.82222C11.25 7.82222 12.6975 5.92593 15.6075 5.92593C18.585 5.92593 21 7.94815 21 12.0444V20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.946bcd474253eb7948fc517bd5b4838e.svg";
export { ForwardRef as ReactComponent };